export default __webpack_public_path__ + "static/media/headerImageOriginal.aceed73e.jpg";